import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=37228ecb&scoped=true"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37228ecb",
  null
  
)

export default component.exports